module.exports = __webpack_public_path__ + "img/44.ed37419b.png";